export default __webpack_public_path__ + "static/media/google-play.dd90f63a.png";